import React from 'react';
import PropTypes from 'prop-types';

import CriteriumCompetitors from '@hydra/common/criterium/CriteriumCompetitors';
import CriteriumGooglePreview from '@hydra/common/criterium/CriteriumGooglePreview';
import Criterium from '@hydra/common/criterium/Criterium';
import hasCritData from '@hydra/utils/hasCritData';

export const GooglePreview = ({ criterium, competitors = [] }) => {
  const { data, url } = criterium;

  const missing = !data.desktop.url || !data.desktop.title || !data.desktop.description;

  const singleContent = <CriteriumGooglePreview missing={missing} {...data} url={url} />;
  let compContent;
  if (competitors.length > 0) {
    const compComponents = [
      { component: singleContent, url },
      ...competitors.map(({ criteria }) => {
        if (!hasCritData(criteria.google_preview)) {
          return null;
        }
        const { data, url } = criteria.google_preview;
        const missing = !data.desktop.url || !data.desktop.title || !data.desktop.description;
        return {
          component: <CriteriumGooglePreview missing={missing} {...data} url={url} />,
          url
        };
      })
    ];
    compContent = <CriteriumCompetitors competitors={compComponents} />;
  }

  return <Criterium criterium={criterium}>{compContent || singleContent}</Criterium>;
};

GooglePreview.propTypes = {
  competitors: PropTypes.arrayOf(
    PropTypes.shape({
      criteria: PropTypes.shape({
        google_preview: PropTypes.shape({
          url: PropTypes.string,
          data: PropTypes.shape({
            desktop: PropTypes.shape({
              title: PropTypes.string,
              description: PropTypes.string,
              url: PropTypes.string
            }),
            mobile: PropTypes.shape({
              title: PropTypes.string,
              description: PropTypes.string,
              url: PropTypes.string
            })
          })
        })
      }),
      color: PropTypes.string
    })
  ),
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      desktop: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        url: PropTypes.string
      })
    })
  })
};

export default React.memo(GooglePreview);
